import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    badgeLabel: string;
    dialogLabel: string;
    singleTitle: string;
    bulkTitle: (num: number) => string | React.ReactNode;
    description: string;
    bulkDescription: string;
    addAsMember: string;
    addAsMembers: string;
    moveSingleGuest: string;
    moveMultipleGuests: string;
    upgradeRate: (rate: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Text for the label of the badge that displays the guest avatar in the existing guest dialog */
            badgeLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExistingGuestDialog.badgeLabel?c=1h34zwst9gtat", defaultMessage: "Guest avatar" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the label of the dialog that displays the existing guest dialog */
            dialogLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExistingGuestDialog.dialogLabel?c=1yrxl5ud4pdjr", defaultMessage: "Existing Guest" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the title of the single guest dialog */
            singleTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExistingGuestDialog.singleTitle?c=3d6vz5pr1zlnd", defaultMessage: "Move Guest to This Project?" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the title of the multiple guest dialog */
            bulkTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (num: number) => __intl__.intl().formatMessage({ id: "ExistingGuestDialog.bulkTitle?c=57rmfyw07vfu", defaultMessage: "{num, plural, one {Move {num} Guest to This Project?} other {Move {num} Guests to This Project?}}" }, { num: num }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the description of the existing guest dialog */
            description: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExistingGuestDialog.description?c=3jfzjx27avo5x", defaultMessage: "Guests can only access one project at a time. Adding this Guest will remove them from their existing project." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the description of the multiple guest dialog */
            bulkDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExistingGuestDialog.bulkDescription?c=2g6q5imfx2hfl", defaultMessage: "Guests can only access one project at a time. Adding these Guests will remove them from their existing project." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the button that adds the guest as a member in the existing guest dialog */
            addAsMember: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExistingGuestDialog.addAsMember?c=3oe901rutf4rn", defaultMessage: "Add as Member" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the button that adds the guests as members in the existing guest dialog */
            addAsMembers: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExistingGuestDialog.addAsMembers?c=1cq3kzfxwx32", defaultMessage: "Add as Members" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the button that moves the guest in the existing guest dialog */
            moveSingleGuest: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExistingGuestDialog.moveSingleGuest?c=1ieffmf20kbiz", defaultMessage: "Move Guest" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the button that moves the guests in the existing guest dialog */
            moveMultipleGuests: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ExistingGuestDialog.moveMultipleGuests?c=7tm5psda5ezi", defaultMessage: "Move Guests" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the upgrade rate of the existing guest dialog. Rate example: $10/mo */
            upgradeRate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (rate: string) => __intl__.intl().formatMessage({ id: "ExistingGuestDialog.upgradeRate?c=om9t3h8tjl7k", defaultMessage: "{rate} (plus tax) per new Member" }, { rate: rate }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
